import { Toaster } from "react-hot-toast";
import LoginPage from "./pages/loginPage";
import DashboardPage from "./pages/dashboardPage";
import SignupPage from "./pages/signupPage";
import { Route, Routes } from "react-router-dom";
import React from "react";
import ProtectedRoute from "./utils/protectedRoute";
import CreateRoomPage from "./pages/createRoomPage";
import JoinRoomPage from "./pages/joinRoomPage";
import RoomPage from "./pages/roomPage";
import HomePage from "./pages/homePage";
import EtherScanPage from "./pages/etherScanPage";
import MempoolPage from "./pages/mempoolPage";
import RoomDashBoardPage from "./pages/RoomDashBoardPage";
import TransactionPage from "./pages/transactionPage";
import BlocksPage from "./pages/blocksPage";
import HackRoomDashboardPage from "./pages/hackRoomDashboardPage";
import HackEtherScanPage from "./pages/hackEtherScanPage";
import HackMempoolPage from "./pages/hackMempoolPage";
import HackBlocksPage from "./pages/hackBlocksPage";
import HackTransactionPage from "./pages/hackTransactionPage";
import CreateNftPage from "./pages/createNft";
import HackLeaderboardPage from "./pages/hackLeaderboardPage";
import HackCreateTransactionPage from "./pages/hackCreateTransactionPage";

function App() {
  return (
    <>
      <Toaster />
      <Routes>
        <Route path="/" element={<HomePage />} />
        {/* <Route path="/contact" element={<ContactPage />} /> */}
        <Route path="/login" element={<LoginPage />} />
        <Route path="/signup" element={<SignupPage />} />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              {" "}
              <DashboardPage />{" "}
            </ProtectedRoute>
          }
        />
        <Route
          path="/create-nft"
          element={
            <ProtectedRoute>
              {" "}
              <CreateNftPage />{" "}
            </ProtectedRoute>
          }
        />

        <Route
          path="/create-room"
          element={
            <ProtectedRoute>
              {" "}
              <CreateRoomPage />{" "}
            </ProtectedRoute>
          }
        />
        <Route
          path="/join-room"
          element={
            <ProtectedRoute>
              {" "}
              <JoinRoomPage />{" "}
            </ProtectedRoute>
          }
        />
        <Route
          path="/room/:roomId"
          element={
            <ProtectedRoute>
              {" "}
              <RoomPage />{" "}
            </ProtectedRoute>
          }
        />
        <Route
          path="/etherscan"
          element={
            <ProtectedRoute>
              {" "}
              <EtherScanPage />{" "}
            </ProtectedRoute>
          }
        />
        <Route
          path="/mempool"
          element={
            <ProtectedRoute>
              <MempoolPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/joinedroom/"
          element={
            <ProtectedRoute>
              {" "}
              <RoomDashBoardPage />{" "}
            </ProtectedRoute>
          }
        />
        <Route
          path="/transaction"
          element={
            <ProtectedRoute>
              {" "}
              <TransactionPage />{" "}
            </ProtectedRoute>
          }
        />
        <Route
          path="/blocks"
          element={
            <ProtectedRoute>
              {" "}
              <BlocksPage />{" "}
            </ProtectedRoute>
          }
        />
        <Route
          path="/joinedhack"
          element={
            <ProtectedRoute>
              {" "}
              <HackRoomDashboardPage />{" "}
            </ProtectedRoute>
          }
        />
        <Route
          path="/etherscanhack"
          element={
            <ProtectedRoute>
              {" "}
              <HackEtherScanPage />{" "}
            </ProtectedRoute>
          }
        />
        <Route
          path="/mempoolhack"
          element={
            <ProtectedRoute>
              {" "}
              <HackMempoolPage />{" "}
            </ProtectedRoute>
          }
        />
        <Route
          path="/hackblocks"
          element={
            <ProtectedRoute>
              {" "}
              <HackBlocksPage />{" "}
            </ProtectedRoute>
          }
        />
        <Route
          path="/transactionhack"
          element={
            <ProtectedRoute>
              {" "}
              <HackTransactionPage />{" "}
            </ProtectedRoute>
          }
        />
        <Route
          path="/leaderboardhack"
          element={
            <ProtectedRoute>
              {" "}
              <HackLeaderboardPage />{" "}
            </ProtectedRoute>
          }
        />
        <Route
          path="/createtransactionhack"
          element={
            <ProtectedRoute>
              {" "}
              <HackCreateTransactionPage />{" "}
            </ProtectedRoute>
          }
        />
      </Routes>
    </>
  );
}

export default App;
